import { keys } from "../constants";
import MenuContext from "../menu.context";
import { CachedItem, storage } from "@lib-shared/lib";

const connectCache = CachedItem.withoutPrefix(keys.connectAccess);
const selfServiceUserCache = CachedItem.withoutPrefix(keys.selfServiceUser);

const determineIfLoggedIn = (context: MenuContext, e: any = null) => {
    const config = context.config;

    if (!config.ciamFlag) {
        // if (!connectCache.isCached) {
        context.updateIsLoggedIn(connectCache.isCached || selfServiceUserCache.isCached);
        return;
        // }

        // const connectStore = connectCache.value;
        // const status = connectStore?.customer_status;

        // const isLoggedIn = status === "Authenticated"
        // context.updateIsLoggedIn(isLoggedIn);
        // return;
    }

    const access = storage.contains(keys.ciamAccess);
    const isLoggedIn = access && storage.contains(keys.loggedInBusinessUser);
    context.updateIsLoggedIn(isLoggedIn);
}

export default determineIfLoggedIn;